import { useEffect, useState } from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import api from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";

export default function AdminSettings() {
  const { t } = useLanguage();
  const [form, setForm] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => setForm(data)).catch(() => {});
  }, []);

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleSave = async (e) => {
    e.preventDefault();
    await api.put("/admin/settings", form);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  if (!form) return <p className="text-white/50">{t("common.loading")}</p>;

  return (
    <div data-testid="admin-settings-page">
      <h1 className="font-serif text-2xl sm:text-3xl text-white mb-8">{t("admin.settings.title")}</h1>

      <form onSubmit={handleSave} className="max-w-2xl space-y-8">
        <section>
          <h2 className="text-white text-lg mb-4">{t("admin.settings.businessInfo")}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field label={t("admin.settings.businessName")} testId="settings-business-name" value={form.business_name} onChange={set("business_name")} />
            <Field label={t("admin.settings.phone")} testId="settings-phone" value={form.phone} onChange={set("phone")} />
            <Field label={t("admin.settings.address")} testId="settings-address" value={form.address} onChange={set("address")} />
            <Field label={t("admin.settings.postalCode")} testId="settings-postal-code" value={form.postal_code} onChange={set("postal_code")} />
            <Field label={t("admin.settings.city")} testId="settings-city" value={form.city} onChange={set("city")} />
            <Field label={t("admin.settings.country")} testId="settings-country" value={form.country} onChange={set("country")} />
            <Field label={t("admin.settings.mapsUrl")} testId="settings-maps-url" value={form.google_maps_embed_url} onChange={set("google_maps_embed_url")} className="sm:col-span-2" />
            <Field label={t("admin.settings.reviewScore")} testId="settings-review-score" type="number" step="0.1" value={form.review_score} onChange={set("review_score")} />
            <Field label={t("admin.settings.reviewCount")} testId="settings-review-count" type="number" value={form.review_count} onChange={set("review_count")} />
          </div>
        </section>

        <section>
          <h2 className="text-white text-lg mb-4">{t("admin.settings.legalInfo")}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field label={t("admin.settings.legalName")} testId="settings-legal-name" value={form.legal_name} onChange={set("legal_name")} />
            <Field label={t("admin.settings.kvkNumber")} testId="settings-kvk-number" value={form.kvk_number} onChange={set("kvk_number")} />
            <Field label={t("admin.settings.email")} testId="settings-email" value={form.email} onChange={set("email")} />
            <Field label={t("admin.settings.privacyEmail")} testId="settings-privacy-email" value={form.privacy_email} onChange={set("privacy_email")} />
            <Field label={t("admin.settings.retention")} testId="settings-retention" type="number" value={form.data_retention_months} onChange={set("data_retention_months")} />
          </div>
        </section>

        <Button type="submit" data-testid="settings-save-button" className="bg-gold text-white hover:bg-gold-hover rounded-none px-8">
          {saved ? t("common.saved") : t("common.save")}
        </Button>
      </form>
    </div>
  );
}

const Field = ({ label, testId, className, ...props }) => (
  <div className={className}>
    <Label className="text-white/70 text-sm">{label}</Label>
    <Input data-testid={testId} {...props} className="bg-[#1A1A1A] border-white/10 text-white rounded-none mt-1.5" />
  </div>
);
